import {normalize} from '../../util/utils';
import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {HttpStatusCodes} from '../../util/uiconstants';
import _ from 'lodash';
const extractDocumentId = (action) => {
	return action.documentId || action?.meta?.api?.data?.documentId || action?.data?.documentId;
};

const deleteSCOTFromStore = (scotId, state, isManageScots = false) => {
	if (isManageScots) {
		let newState = _.cloneDeep(state);
		if (state.manageScots) {
			newState.manageScots.data = state.manageScots.data.filter((scot) => {
				return scot.id !== scotId;
			});
		}
		return newState;
	}
	return {
		...state,
		byId: {
			...state.byId
		},
		allIds: state.allIds?.filter((id) => {
			return id !== scotId;
		})
	};
};

export function scotsDetailsReducer(state = initialstate.scotsDetails, action) {
	switch (action.type) {
		case types.GET_SCOT_BY_ID:
			return action.response || state;
		case types.CLEAN_SCOT:
			return initialstate.scotsDetails;
		case types.RELATE_ITAPP_TO_SCOT:
			//To Do: Need to handle error scenario
			if (action?.itApplicationItem && !action.error) {
				let newState = _.cloneDeep(state);
				if (newState.itApplications) {
					newState.itApplications = [...newState.itApplications, action.itApplicationItem];
				} else {
					newState.itApplications = [action.itApplicationItem];
				}
				// Sort itApplications in alphanumeric order by name (case-insensitive)
				newState.itApplications.sort((a, b) => {
					const nameA = (a.itApplicationName || '').toLowerCase();
					const nameB = (b.itApplicationName || '').toLowerCase();
					return nameA.localeCompare(nameB);
				});
				return newState;
			}
		case types.UNRELATE_ITAPP_FROM_SCOT:
			if (action && !action.error) {
				let newState = _.cloneDeep(state);
				const {scotId, ITApplicationId} = action;
				if (newState.itApplications.length > 0) {
					newState.itApplications = newState.itApplications.filter((app) => app.id !== ITApplicationId);
				}
				return newState;
			}
			return state;
		case types.UPDATE_DOCUMENT:
		case types.POST_RNH_NEW_NOTE:
		case types.UPDATE_RNH_NOTE_DETAIL: {
			if ([HttpStatusCodes.Ok, HttpStatusCodes.Created].includes(action?.responseObj?.status) && state.relatedDocuments) {
				const documentId = extractDocumentId(action);

				if (!documentId) return state;

				const actionData = action.type === types.UPDATE_RNH_NOTE_DETAIL ? action.data : action?.meta?.api?.data || action;
				const {documentName = null, isEPSignoffUserRequired = null, isEQRSignoffUserRequired = null} = actionData;

				return {
					...state,
					relatedDocuments: state.relatedDocuments.map((document) => {
						if (document.id !== documentId) return document;

						let engagementReviewNoteCount = document?.engagementReviewNoteCount || 0;

						if (action.type === types.POST_RNH_NEW_NOTE) {
							engagementReviewNoteCount++;
						} else if (action.type === types.UPDATE_RNH_NOTE_DETAIL) {
							const {statusIdChanged, isOpening} = actionData;
							if (statusIdChanged && isOpening) {
								engagementReviewNoteCount++;
							} else if (action.previousStatusId === 1) {
								engagementReviewNoteCount--;
							}
						}

						return {
							...document,
							documentName: documentName ?? document.documentName,
							isEPSignoffUserRequired: isEPSignoffUserRequired ?? document.isEPSignoffUserRequired,
							isEQRSignoffUserRequired: isEQRSignoffUserRequired ?? document.isEQRSignoffUserRequired,
							engagementReviewNoteCount
						};
					})
				};
			}
			return state;
		}
		case types.ADD_ENTITY_DOCUMENT_SIGNOFF: {
			if (!action.error && state.relatedDocuments) {
				return {
					...state,
					relatedDocuments: state.relatedDocuments.map((document) => {
						if (document.id !== action.documentId) return document;

						const signoffExists = (document.approvals || []).some(
							(approval) => approval.approvalId === action.documentSignoff.approvalId || approval.id === action.documentSignoff.approvalId
						);

						if (signoffExists) return document;

						return {
							...document,
							approvals: [...(document.approvals || []), action.documentSignoff]
						};
					})
				};
			}
			return state;
		}
		case types.REMOVE_ENTITY_DOCUMENT_SIGNOFF: {
			if (!action.error && state.relatedDocuments) {
				return {
					...state,
					relatedDocuments: state.relatedDocuments.map((document) => {
						if (document.id !== action.documentId) return document;

						return {
							...document,
							approvals: (document.approvals || []).filter((approval) => approval.approvalId !== action.approvalId && approval.id !== action.approvalId)
						};
					})
				};
			}
			return state;
		}
		case types.DELETE_DOCUMENT_BY_ID: {
			if (!action.error && state.relatedDocuments) {
				return {
					...state,
					relatedDocuments: state.relatedDocuments.filter((document) => document.id !== action.documentId)
				};
			}
			return state;
		}
		default:
			return state;
	}
}

export function scotsWalkthroughReducer(state = initialstate.scots, action) {
	switch (action.type) {
		case types.GET_ENGAGEMENT_ALL_SCOTS_SAME_API_SORTING:
			if (action.response && action.response.data && !action.error) {
				const scotsList = {
					scotsData: action.response.data
				};
				scotsList.pages = action.response.pages;
				scotsList.page = action.response?.page;
				scotsList.totalEntityCount = action.response.totalEntityCount;
				return {...state, ...scotsList};
			}
			return state;
		default:
			return state;
	}
}
export function scotsReducer(state = initialstate.scots, action) {
	switch (action.type) {
		case types.GET_ALL_SCOTS: {
			if (action.responseObj && action.responseObj.status === HttpStatusCodes.Ok) {
				return { ...state, manageScots: action.responseObj.data };
			}
			return state;
		}

		case types.GET_SCOTS_FOR_ASSERTIONIDS:
			return action.response || state;

		case types.SAVE_RISK_WCGW_SELECTION: {
			let temp = [{}];
			Object.assign(temp, state);

			temp[0].scots.map((x) => {
				if (x.scotId === action.scotId) {
					for (let i = 0; i < action.data.length; i++) {
						let actionWcgw = action.data[i];
						for (let j = 0; j < x.wcgws.length; j++) {
							if ('/Wcgw/' + x.wcgws[j].wcgwId === actionWcgw.id) {
								x.wcgws[j] = {...x.wcgws[j], selected: actionWcgw.checked};
							}
						}
					}
				}
				return x;
			});
			return temp || state;
		}

		case types.GET_ENGAGEMENT_ALL_SCOTS:
			if (action.response && action.response.data && !action.error) {
				if (action?.isManageScots) {
					let newState = _.cloneDeep(state);
					return {...newState, manageScots: action.response};
				}

				let newState = _.cloneDeep(action.response.data);
				if (action.includeEstimates !== undefined && action.includeEstimates) {
					newState = newState.map((scot) => {
						if (scot.id === 0) return {...scot, id: scot.uniqueId};
						return scot;
					});
				}

				const scotsList = normalize(newState);
				scotsList.pages = action.response.pages;
				scotsList.page = action.response?.page;
				scotsList.totalEntityCount = action.response.totalEntityCount;
				return {...state, ...scotsList};
			}
			return state;
		case types.CREATE_SCOT:
			if (action.response && !action.error) {
				let newState = _.cloneDeep(state);
				if (action.isManageScots) {
					newState.manageScots = newState.manageScots || {};
					newState.manageScots.data = [...(state.manageScots?.data || []), action.response];
					return newState;
				}

				newState = action.response;
				newState.byId = {
					...state.byId,
					[action.response.id]: action.response
				};
				newState.allIds = [...(state.allIds || []), action.response.id];
				return newState;
			}
			return state;

		case types.UPDATE_GET_ALL_SCOTS_STORE_BY_ID:
			if (action.response) {
				let newState = _.cloneDeep(state);
				// let toBeUpdateIndex = state.allIds.findIndex(x => x === action.response.id);
				newState.byId = {
					...state?.byId,
					[action.response.id]: {
						...[state?.byId && state?.byId[action.response.id]],
						...action.response
					}
				};
				return newState;
			}
			return state;

		case types.GET_SCOT_BY_ID:
			if (action?.error?.response?.status === HttpStatusCodes.NotFound) {
				return deleteSCOTFromStore(action.scotId, state, action?.isManageScots); // If the Scot is not found, remove it from the list (concurrency scenario)
			}
			return state;

		case types.UPDATE_SCOT: {
			if (action.response && !action.error && Object.keys(state).length > 0) {
				let newState = _.cloneDeep(state);
				if (action.isManageScots) {
					if (!newState.manageScots) {
						newState.manageScots = {data: [action.response]};
					} else if (newState.manageScots.data.length === 0) {
						newState.manageScots.data = [action.response];
					} else {
						const updatedScots = newState.manageScots.data.filter((e) => e.id !== action.response.id);
						newState.manageScots.data = [...updatedScots, action.response];
					}
				} else {
					newState.byId = {
						...state?.byId,
						[action.response.id]: {
							...[state?.byId && state?.byId[action.response.id]],
							...action.response
						}
					};
				}
				return newState;
			} else if (action?.error?.response?.status === HttpStatusCodes.BadRequest) {
				// If the Scot is not found, remove it from the list (concurrency scenario)
				return deleteSCOTFromStore(action?.meta?.api?.data?.id, state, action?.isManageScots);
			}
			return state;
		}

		case types.GET_SCOTS_BY_ENG:
			return action.response?.data || state;

		case types.DELETE_SCOT: {
			if (action.responseObj.status === HttpStatusCodes.NoContent || action.error.response?.status === HttpStatusCodes.NotFound) {
				return deleteSCOTFromStore(action.scotId, state, action?.isManageScots);
			}
			return state;
		}
		case types.APPEND_ACCOUNT_TO_SCOT: {
			if (action.payload && !action.error) {
				let newState = _.cloneDeep(state);
				const {scotId, data} = action.payload;
				if (newState.byId && newState.byId[scotId]) {
					const scot = newState.byId[scotId];
					// Ensure scot.accounts is an array
					scot.accounts = Array.isArray(scot.accounts) ? scot.accounts : [];
					// Append account details from data (assuming data contains account details)
					scot.accounts = [...scot.accounts, ...[].concat(data)];
					newState.byId[scotId] = scot;
				}
				return newState;
			}
		}
		case types.DELETE_ACCOUNT_FROM_SCOT: {
			if (action.payload && !action.error) {
				let newState = _.cloneDeep(state);
				const {scotId, data} = action.payload;
				if (newState.byId && newState.byId[scotId]) {
					const scot = newState.byId[scotId];
					// Ensure scot.accounts is an array
					scot.accounts = Array.isArray(scot.accounts) ? scot.accounts : [];
					// Remove the account with the specified accountId from data
					scot.accounts = scot.accounts.filter((account) => account.accountId !== data.accountId);
					newState.byId[scotId] = scot;
				}
				return newState;
			}
		}
		case types.CLEAR_SCOTS:
			return {};
		default:
			return state;
	}
}

// pull scots from api results
export function formatScots(scots) {
	let formattedScots = {};
	if (scots && scots[0] && scots[0].scots && scots[0].scots.length > 0) {
		formattedScots = scots[0].scots;
		formattedScots.riskId = scots[0].riskId;
		formattedScots.assertionId = scots[0].assertions[0].id;
	}
	return formattedScots;
}

export function scotReducer(state = initialstate.scot, action) {
	switch (action.type) {
		case types.CREATE_SCOT:
			if (action.response && !action.error) {
				let newState = _.cloneDeep(state);

				if (action.isManageScots) {
					let newState = _.cloneDeep(state);
					if (newState?.manageScots?.data) {
						let scotsData = newState.manageScots.data.filter((e) => e.id !== action.response.id);
						newState.manageScots.data = [...scotsData, action.response];
					}
					return newState;
				}
				newState = action.response;
				return newState;
			}
			return state;
		default:
			return state;
	}
}
